import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { TrLibModule } from '../tr-lib.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { surveyDialogDefaultOptions } from '../study-survey/models';
import { MaterialImportsModule } from '../material-imports.module';
import { GotoBackLinkModule } from '../goto-back-link/goto-back-link.module';
import { SurveyPipesModule } from '../pipes/survey-pipes.module';
import { ModuleSettingsModule } from '../module-settings/module-settings.module';
import { ConsentModule } from '../consent/consent.module';
import { WidgetsModule } from '../widgets/widgets.module';
import { StudySurveyStoreModule } from '../study-survey/store/study-survey-store.module';
import { ContactInfoModule } from '../contact-info/contact-info.module';

import { DataInsightsRoutingModule } from './data-insights-routing.module';
import { CqDataInsightsComponent } from './components/cq-data-insights/cq-data-insights.component';
import { AgeDiagnosisChartComponent } from './components/cq-data-insights/charts/age-diagnosis-chart/age-diagnosis-chart.component';
import { AutoimmuneDiseaseChartComponent } from './components/cq-data-insights/charts/autoimmune-disease-chart/autoimmune-disease-chart.component';
import { CgmUsageChartComponent } from './components/cq-data-insights/charts/cgm-usage-chart/cgm-usage-chart.component';
import { DurationDiabetesChartComponent } from './components/cq-data-insights/charts/duration-diabetes-chart/duration-diabetes-chart.component';
import { FamilyHistoryChartComponent } from './components/cq-data-insights/charts/family-history-chart/family-history-chart.component';
import { GlpUsageChartComponent } from './components/cq-data-insights/charts/glp-usage-chart/glp-usage-chart.component';
import { DataInsightStoreModule } from './store/data-insight-store.module';

@NgModule({
    imports: [
    TrLibModule,
    DataInsightsRoutingModule,
    GotoBackLinkModule,
    SurveyPipesModule,
    ModuleSettingsModule,
    TrLibModule,
    ConsentModule,
    WidgetsModule,
    StudySurveyStoreModule,
    ContactInfoModule,
    CommonModule,
    DataInsightStoreModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialImportsModule,
    ],
    declarations: [
    CqDataInsightsComponent,
    AgeDiagnosisChartComponent,
    AutoimmuneDiseaseChartComponent,
    CgmUsageChartComponent,
    DurationDiabetesChartComponent,
    FamilyHistoryChartComponent,
    GlpUsageChartComponent
    ],
    providers: [{provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: surveyDialogDefaultOptions}],
    exports: []
})
export class DataInsightsmodule {}